module.exports = __webpack_public_path__ + "53453fb02a6ffce69e61b8b64bbf0fd8.jpg";